module.exports = __webpack_public_path__ + "static/media/sparrow-eating-momo.349d54a1.png";